import * as React from 'react';

function SvgPin(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M11.903 5.981a3 3 0 100 6 3 3 0 000-6zm0 4.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3z" />
      <path d="M17.668 3.212A8.153 8.153 0 005.072 13.426l5.667 8.7a1.388 1.388 0 002.327 0l5.668-8.7a8.153 8.153 0 00-1.067-10.214zm-.191 9.395l-5.574 8.557-5.575-8.557a6.683 6.683 0 01.87-8.335 6.652 6.652 0 019.409 0 6.683 6.683 0 01.87 8.335z" />
    </svg>
  );
}

export default SvgPin;
